module.exports = __webpack_public_path__ + "static/rpm_basico-33fd3b409680f4e8fa98082ed54a5fa9.png";